/**
 * Returns an array containing all elements of the input iterable.
 *
 * @example
 * // return [0,1,2]
 * list( range( 3 ) ) ;
 *
 * @function
 * @param {Iterable} iterable The input Iterable.
 * @returns {Array} The output Array.
 *
 */
export const list = Array.from;
